<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel w-65pc active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ panelHeader }}</h2>
          <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnShowConfigureshowLoggingAlertPanel()">
            {{ "label_log" | translate }}
          </button>
          <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{'disabled':!hasFormChanges}" (click)="Save()">
            {{'label_save' | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()"
          *ngIf="!fmSpecialObject || fmSpecialObject.type != 1">
            {{ 'back_to_wizard' | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()"
          *ngIf="fmSpecialObject && fmSpecialObject.type == 1">
            {{ 'label_close' | translate }}
          </button>
      </div>
    </header>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
          <div class="block padding-top-10">
            <div class="row">
              <h6 class="w-100pc padding-bottom-5 border-bottom">{{'single_tax_tax_with_multiple_components' | translate:param}}</h6>
                <ul class="info-panel">
                  <li class="cursor-pointer">
                     <div class="row f-13 lH-normal padding-left-30 position-relative">
                        <span class="position-absolute left-0px top-10px">
                          <input type="radio"
                              class="align-middle svg-20 padding-right-5"
                              id="customSwitchRule1"
                              value="1"
                              [checked]="setVAT"    
                              (change)="fnSetVATtype(1,true)"                               
                              name="vatType"> </span>
                        <div class="float-left w-100pc text-left">
                            <p class="lH-normal f-14 d-flex justify-content-between"> 
                                <span class="w-80pc font-weight-bold f-14">{{ "do_you_have_single_tax_rate" | translate }}</span>   
                                <span class="w-20pc padding-left-10 f-14 fw-600">{{ "this_is_typically" | translate }}:<span class='color-red f-14 padding-left-5 fw-600'>{{ "tax_vat" | translate }}</span></span> </p>
                        </div>
                    </div>
                </li>
                <li class="cursor-pointer">
                    <div class="row f-13 lH-normal padding-left-30 position-relative">
                      <span class="position-absolute left-0px top-10px">
                        <input type="radio"
                            class="align-middle svg-20 padding-right-5"
                            id="customSwitchRule2"
                            value="1"
                            [checked]="setGST" 
                            (change)="fnSetVATtype(2,true)"                               
                            name="vatType"> </span>
                      <div class="float-left w-100pc text-left">
                          <p class="lH-normal  f-14 d-flex justify-content-between"> 
                              <span class="w-80pc font-weight-bold">{{ "do_you_have_component_based_tax_rate" | translate }}</span>   
                              <span class="w-20pc padding-left-10 f-14 fw-600">{{ "this_is_typically" | translate }}:<span class='color-red f-14 padding-left-5 fw-600'>{{ "tax_gst" | translate }}</span></span> </p>
                      </div>
                  </div>          
                    <div class="row padding-left-30 padding-top-10" *ngIf="!IsSingleRate && IsINRCurrency">
                      <div class="row">
                        <div class="col-md-12 col-sm-12 no-padding-right-left">
                          {{'please_select_your_home_state_where_you_are_registered_for_gst' | translate:param}}
                        </div>
                      </div>
                      <div class="input-group">
                        <ng-select class="custom solo-dropdown taxsetup-state-name" [items]="statesList" bindLabel="stateName"
                          bindValue="stateId" [(ngModel)]="StateIdSelected" placeholder="Select State" [selectOnTab]="true"
                          (change)="stateChanged($event)" [clearable]="false" required-field
                          notFoundText="{{ 'no_data_available' | translate: param }}">
                        </ng-select>
                        <div *ngIf = "isStateNotSelected" class="alert-danger">
                          {{'required_validation' | translate}}
                        </div>
                    </div>
                    </div>
                </li>
            </ul>
          </div>     
        </div>   
        <div class="block padding-top-10 ">
          <div class="row">
              <h6 class="w-100pc padding-bottom-5 border-bottom">{{'set_tax_name' | translate:param}}</h6>
              <div class="input-group margin-top-20">
                  <input type="text"  class="form-control has-value" [placeholder]="taxNamePlaceHolder"
                  name="RateCode" autocomplete="off" (input)="onTaxNameChange()" [(ngModel)]="RateCode"
                  #TaxNameValue id="tax-name-guide" />
                  <label for="">{{'give_tax_name' | translate:param}}<span class="color-red">*</span></label>                 
              </div>              
              <div *ngIf="
                          (TaxNameValue.value == '' && hasFormChanges) ||
                          (hasFormChanges && RateCode.trim() === '')
                        " class="alert-danger">
                <b>{{'required_validation' | translate:param}}</b>
              </div>              
          </div>                
      </div>  
      </div>
    </div>
  </div>
</div>

<app-alert-panel [data]="taxChangeAlertPanelModel" (callbackEvent)="fnCloseTaxChangeAlertPanel($event)"></app-alert-panel>